// extracted by mini-css-extract-plugin
export default {"wrapper":"credits_wrapper__zmvdK","credits":"credits_credits__alXUb","rollover":"credits_rollover__LFatE","button":"credits_button__A0Zru"};